import { gql } from "@apollo/client";

import ArtifactComponentFragment from "@apps/artifact/graphql/artifact-component-fragment";

export default gql`
  ${ArtifactComponentFragment}
  query getProfileArtifactsQuery(
    $goalOwners: [Int]
    $artifactType: ArtifactType!
    $goalStates: [GoalState]
    $first: Int
    $last: Int
    $feedbackRecipient: Int
    $recognitionRecipient: Int
    $actionItemIsComplete: Boolean
    $actionItemAssignee: Int
    $orderBy: String
    $after: String
  ) {
    artifacts(
      goalOwners: $goalOwners
      artifactType: $artifactType
      goalStates: $goalStates
      first: $first
      last: $last
      after: $after
      feedbackRecipient: $feedbackRecipient
      actionItemIsComplete: $actionItemIsComplete
      actionItemAssignee: $actionItemAssignee
      recognitionRecipient: $recognitionRecipient
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...ArtifactComponentFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
